import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useCart } from '../../contexts/CartContext';
import CartButton from '../../components/feature/CartButton';

export default function ProductsPage() {
  const [scrolled, setScrolled] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [addedToCart, setAddedToCart] = useState<number | null>(null);
  const [selectedCategory, setSelectedCategory] = useState<string>('All');
  const [expandedDescriptions, setExpandedDescriptions] = useState<{ [key: number]: boolean }>({});
  const { addToCart } = useCart();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleAddToCart = (product: any, e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation();
    }
    addToCart(product);
    setAddedToCart(product.id);
    setTimeout(() => setAddedToCart(null), 2000);
  };

  const toggleDescription = (productId: number, e: React.MouseEvent) => {
    e.stopPropagation();
    setExpandedDescriptions(prev => ({
      ...prev,
      [productId]: !prev[productId]
    }));
  };

  const allProducts = [
    {
      id: 1,
      name: 'Clean Detox',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦28,000',
      rating: 5,
      reviews: 127,
      bg: 'bg-rose-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/6e120bfc8043ea77825d5145e57e2953.jpeg',
      description: `CLEAN DETOX CAPSULE is an age-old ayurvedic formulation. Designed to stimulate digestive fire, promote bile flow, and help in liver detoxification. Combined with Noni to reduce cholesterol and triglycerides, drop- down painful imflammationand swelling. With the addition of Gilloy, Clean Detox is effective for blood sugar control, brings down dengue fever, and is an antipyritic agent. It is useful in burning stomach fats due to the presence of Kachnar guggul, Varunchal and Choti Elaichi, helps in treating prostate enlargement and bladder sensitivity. Reduces the weight of the prostate gland and maintains urineflow. Detoxify bad breath, cleanse your whole body, and fights free radicals.DO YOU KNOW: Clean Detox will boost yourimmune system while detoxifying your viscera organs. As you experience the detoxifying effect of Clean Detox, identify how you fight against free radicals, makes you look younger, and enjoy the healing powers released on you by our age-old ayuvadic formulation, the Clean Detox`,
      category: 'Detox & Cleanse'
    },
    {
      id: 2,
      name: 'Vita Trace',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦29,900',
      rating: 5,
      reviews: 98,
      bg: 'bg-emerald-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/1ac0f230ef4066a4924563e20feb1190.jpeg',
      description: `VITA TRACE (DOUBLE STEMCELL+) - An amazing combination of supplements and remedies put together makes our Double Stemcell+ a refreshing voice in the wilderness of pathological conditions. Bringing the stemcells of multiple fruits, combined with 16 Ayurvedic remedies that are designed to renew your cells, repair damaged tissues, nerve muscles, neurologic disorder, dementia, reproductive system, respiratory system, circulation system and urinary system. In a wholistic approach, Double Stemcell+ touches an every human organ and gets you completely rejuvenated. Our Double Stemcell+ has anti-inflammatory, antispasmodic and anti-depressant properties that give us the clinical laurel above any other stemcell you may have come across. DO YOU KNOW: Double Stemcell+ can be used on any form of sickness. As you enjoy the rejuvenating force behind our Double Stemcell+, observe how your complaints gradually go down and you can face the future with confidence and renewed hope.`,
      category: 'Cellular Health'
    },
    {
      id: 3,
      name: 'Noni Juice',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦35,000',
      rating: 5,
      reviews: 156,
      bg: 'bg-amber-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/d02458b1e54619b28c4a092f4c0e98a0.jpeg',
      description: `NONI JUICE has been traditionally used for the treatment of inflammation, abscesses, angina, diabetes, abdominal fibroma, scorpionfish sting, cold flu, anxiety and high blood pressure. Muscle aches and pains, menstrual difficulties, headaches, heart diseases, gastric ulcers, sprains, depression, poor digestion, atherosclerosis, and circulation problems. Noni juice also reduces total cholesterol and triglyceride, reduces chronic pains and swelling. Treats parasitic infections, prevents cellular damage caused by smoking and normalizes liver function. Everhealthy Noni Juice is fortified with Brahmi, Kokum fruit, Vaivadang fruit, Alma and Aloe vera to treat Alzheimer's diseases, improve memory, attention deficit, hyperactivity disorder, allergic conditions, irritable bowel syndrome, epilepsy, prevent cancer, dysentery and constipation. Accelerates wound healing, reduce dental plagues, helps to treat cancer sores, burns, allergic reaction, rheumatoid arthritis, skin disease, pile and inflammatory conditions of the digestive system. DO YOU KNOW: Everhealthy Noni juice can be applied directly for Noni juice, discover the wholistic power that is stored in our age-old tradition Ayurveda.`,
      category: 'Wellness Drinks'
    },
    {
      id: 4,
      name: 'FS Desire Capsule',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦20,000',
      rating: 5,
      reviews: 9301,
      bg: 'bg-purple-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/1dd659f395c13bd2d90a61a82f7ae7a8.jpeg',
      description: `FS‑DESIRE CAPSULES is a special formula with anexclusive blend of 14 Ayurvedic remedies. Designed to bring back love and wholistic healing to your sexual life, clear away impotency, bring an end to premature ejaculation and improve your strength. Excellent sexrevival for hypertensive and diabetic patients, suitable for all men and women. Fortified with Ras Sindoor, Trivang Bhasma, Abhrak Bhasma, Pushapadhwa and Shilajit. Careful attention is given to ensure wholistichealing to your sexual powers. Everhealthy FS-Desire capsules will renew your sexual life with wonderful hopeyou will never forget. The Ultimate in Kama sutra!DO YOU KNOW: FS-Desire is not a stimulant. As you takeEverhealthy FS-Desire capsules, discover how powerful you become in the other room and enjoy the wholistic sexual healing that comes with our exclusive formulas,the FS-Desire`,
      category: 'Sexual Health'
    },
    {
      id: 5,
      name: 'Cardamom Tea (Coffee flavour)',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦18,000',
      rating: 5,
      reviews: 89,
      bg: 'bg-orange-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/f47d3f4ba9c5eb073d0a63584c787465.jpeg',
      description: `Cardamom Tea offers a natural, soothing remedy for digestive issues and overall wellness. This aromatic blend combines the warming properties of cardamom with a rich coffee flavor, creating a delightful beverage that supports digestive health, reduces bloating, and promotes overall well-being. Perfect for daily consumption to maintain a healthy digestive system.`,
      category: 'Digestive Health'
    },
    {
      id: 6,
      name: 'Art Plus Tonic',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦30,000',
      rating: 5,
      reviews: 74,
      bg: 'bg-teal-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/33bf822a9a06ecfe19bf122df87b8710.jpeg',
      description: `ART PLUS TONIC is a brain‑support supplement combining 15 Ayurvedic ingredients to improve memory, intelligence, and mental alertness while reducing anxiety and stress. This powerful formulation enhances cognitive function, supports mental clarity, and helps maintain focus throughout the day. Ideal for students, professionals, and anyone seeking to optimize their mental performance.`,
      category: 'Mental Clarity'
    },
    {
      id: 7,
      name: 'Toxem Capsule',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦38,000',
      rating: 5,
      reviews: 112,
      bg: 'bg-lime-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/bd162ab78da015cc7e956950e8ba25af.jpeg',
      description: `Prudent Toxem Capsule is an Ayurvedic detoxifying formula designed to cleanse your body from within. With over 16 herbs, including Ginger, Amla, and Curcumin, this powerful blend eliminates toxins, supports liver function, and promotes overall body purification. Experience renewed energy and vitality as your body naturally cleanses itself.`,
      category: 'Detox & Cleanse'
    },
    {
      id: 8,
      name: 'SomaCare',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦38,000',
      rating: 5,
      reviews: 95,
      bg: 'bg-indigo-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/0cb8f768c265c12a425332c1716b8efc.jpeg',
      description: `SomaCare is a full-spectrum botanical formula designed to rejuvenate and detoxify the body. With a potent blend of 17 super herbs, adaptogens, and antioxidants, SomaCare boosts energy levels, enhances vitality, and supports overall wellness. Perfect for those seeking natural energy and sustained vitality throughout the day.`,
      category: 'Energy & Vitality'
    },
    {
      id: 9,
      name: 'Nutri F (Virus Defence)',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦28,000',
      rating: 5,
      reviews: 67,
      bg: 'bg-red-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/2155e4a7cb97e860d597e291c8497181.jpeg',
      description: `NEUTRI-F CAPSULES is specifically designed to build your body resistance against infections and diseases and also eliminate toxins. It promotes a healthy immune system, strengthens your body's natural defenses, and helps protect against viral infections. Essential for maintaining optimal immune function year-round.`,
      category: 'Immunity'
    },
    {
      id: 10,
      name: 'Dynamic Slim Juice',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦30,000',
      rating: 5,
      reviews: 143,
      bg: 'bg-yellow-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/58c17aea15cb87831f729d39d912966a.jpeg',
      description: `DYNAMIC SLIM JUICE is an excellent ayurvedic herbal product for weight loss. Prepared with Medohar Guggulu, Dynamic slim juice is a wonderful natural solution for healthy weight management. It helps burn fat, boost metabolism, suppress appetite, and support sustainable weight loss while maintaining energy levels.`,
      category: 'Weight Management'
    },
    {
      id: 11,
      name: 'Havitas Tonic',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦30,000',
      rating: 5,
      reviews: 178,
      bg: 'bg-pink-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/ec400f576cea480028d655731732bd17.png',
      description: `HAVITAS JUICE is an exclusive Ayurvedic formula for women. Produced with 16 organic herbs in accord with ayurvedic principles of which Saraca Indica is prominent. This specialized formula supports women's hormonal balance, reproductive health, and overall wellness. Ideal for addressing menstrual irregularities and promoting feminine vitality.`,
      category: "Women's Health"
    },
    {
      id: 12,
      name: 'Behar 3 capsule',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦28,000',
      rating: 5,
      reviews: 967,
      bg: 'bg-cyan-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/6ddc54688ef6a5c29d09201b6c0c9f96.jpeg',
      description: `BEHAR-3 CAPSUSLES: The anti-inflammatory power and pain killer. Behar-3 promotes the healing of bones and protects against chronic conditions like heart disease and arthritis. This powerful formula reduces inflammation, alleviates pain, and supports joint health naturally without harsh side effects.`,
      category: 'Pain Relief'
    },
    {
      id: 13,
      name: 'Pros-X',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦28,000',
      rating: 5,
      reviews: 234,
      bg: 'bg-blue-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/15a49b4ca542b99d1a0a8acc855d40b9.jpeg',
      description: `PROSTATE DISEASE; you want to urinate but you cannot, you have a weak or slow urinating stream, a feeling of incomplete bladder emptying, difficulty starting urination. Pros-X is specifically formulated to support prostate health, improve urinary flow, reduce prostate enlargement, and promote overall male urinary tract wellness.`,
      category: 'Prostate Health'
    },
    {
      id: 14,
      name: 'Softlax',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦28,000',
      rating: 5,
      reviews: 189,
      bg: 'bg-orange-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/8211a314c6b28a3c8558189b3dc93182.jpeg',
      description: `SOFT LAX CAPSULE is a quick healing ayurvedic remedy. It has carminative action and is superb for the maintenance of a healthy digestive system, constipation relief, and regular bowel movements. This gentle formula promotes digestive comfort without harsh laxative effects.`,
      category: 'Digestive Health'
    },
    {
      id: 15,
      name: 'Cushvite-3 Juice',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦30,000',
      rating: 5,
      reviews: 215,
      bg: 'bg-green-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/3f8249b537ed3a9397c0a712fcc11925.png',
      description: `CUSHVITE-3 JUICE, a wonderful remedy for diabetic patients, is formulated to activate the pancreas and increase insulin levels. This Ras increases red blood cells, supports healthy blood sugar levels, improves glucose metabolism, and helps manage diabetes naturally while promoting overall metabolic health.`,
      category: 'Blood Sugar & Diabetes'
    },
    {
      id: 16,
      name: 'DaiboCare',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦38,000',
      rating: 5,
      reviews: 187,
      bg: 'bg-violet-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/45de09a4d0321775c8bec6d6aa97d547.jpeg',
      description: `Prudent DaiboCare is a powerful Ayurvedic formulation designed to combat the root causes of metabolic disorders such as diabetes, liver issues, and poor circulation. This comprehensive formula supports healthy blood sugar levels, liver function, and overall metabolic wellness.`,
      category: 'Blood Sugar & Diabetes'
    }
  ];

  const categories = ['All', ...Array.from(new Set(allProducts.map(p => p.category)))];
  
  const filteredProducts = selectedCategory === 'All' 
    ? allProducts 
    : allProducts.filter(p => p.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/8e2a19642137d9fb9670ecec43a2e980.jpeg" 
                alt="Organic Natural Solution Logo" 
                className="h-12 w-auto"
              />
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => window.scrollTo(0, 0)}>Home</Link>
              <Link to="/about" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => window.scrollTo(0, 0)}>About</Link>
              <Link to="/products" className="text-sm font-medium text-teal-600 transition-colors" onClick={() => window.scrollTo(0, 0)}>Products</Link>
              <Link to="/testimonials" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => window.scrollTo(0, 0)}>Testimonials</Link>
              <Link to="/blog" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => window.scrollTo(0, 0)}>Blog</Link>
              <Link to="/contact" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => window.scrollTo(0, 0)}>Contact</Link>
              <CartButton />
            </div>
            <div className="flex md:hidden items-center gap-4">
              <CartButton />
              <button 
                className="cursor-pointer"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-900`}></i>
              </button>
            </div>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-white shadow-lg">
            <div className="px-6 py-4 space-y-4">
              <Link to="/" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>Home</Link>
              <Link to="/about" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>About</Link>
              <Link to="/products" className="block text-sm font-medium text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>Products</Link>
              <Link to="/testimonials" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>Testimonials</Link>
              <Link to="/blog" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>Blog</Link>
              <Link to="/contact" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>Contact</Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-teal-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Our Premium <span className="text-teal-600">Herbal Products</span>
            </h1>
            <p className="text-xl text-gray-600">
              Discover our complete collection of natural remedies, carefully crafted to support your wellness journey
            </p>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-teal-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {filteredProducts.map((product) => (
              <div 
                key={product.id} 
                className={`${product.bg} rounded-3xl overflow-hidden group transition-all duration-300 hover:shadow-xl`}
              >
                <div className="aspect-square p-6 flex items-center justify-center cursor-pointer" onClick={() => setSelectedProduct(product)}>
                  <img src={product.image} alt={product.name} className="w-full h-full object-contain" />
                </div>
                <div className="bg-white p-6">
                  <p className="text-sm text-gray-500 mb-1">{product.subtitle}</p>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{product.name}</h3>
                  <div className="flex items-center gap-2 mb-3">
                    <div className="flex gap-1">
                      {[...Array(product.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-500 text-sm"></i>
                      ))}
                    </div>
                    <span className="text-xs text-gray-500">({product.reviews})</span>
                  </div>
                  
                  {/* Description Preview */}
                  <div className="mb-4">
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {expandedDescriptions[product.id] 
                        ? product.description 
                        : `${product.description.substring(0, 100)}...`}
                    </p>
                    <button
                      onClick={(e) => toggleDescription(product.id, e)}
                      className="text-teal-600 text-sm font-medium mt-2 hover:underline cursor-pointer"
                    >
                      {expandedDescriptions[product.id] ? 'Show Less' : 'Read Full Description'}
                    </button>
                  </div>

                  <div className="flex items-center justify-between">
                    <div className="flex flex-col">
                      <span className="text-sm text-gray-400 line-through">
                        ₦{Math.round(parseFloat(product.price.replace(/[^0-9.]/g, '')) * 1.15).toLocaleString()}
                      </span>
                      <span className="text-2xl font-bold text-gray-900">{product.price}</span>
                    </div>
                    <button 
                      className={`w-10 h-10 flex items-center justify-center rounded-full transition-all duration-300 ${
                        addedToCart === product.id 
                          ? 'bg-teal-600 text-white' 
                          : 'bg-gray-900 text-white hover:bg-teal-600'
                      }`}
                      onClick={(e) => handleAddToCart(product, e)}
                    >
                      <i className={`${addedToCart === product.id ? 'ri-check-line' : 'ri-shopping-cart-line'}`}></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            <div>
              <img src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/8e2a19642137d9fb9670ecec43a2e980.jpeg" alt="Organic Natural Solution Logo" className="h-12 w-auto mb-6" />
              <p className="text-gray-400 leading-relaxed mb-6">
                Dedicated to providing the highest quality herbal remedies that honor traditional wisdom while meeting modern wellness needs.
              </p>
              <div className="flex gap-4">
                <a href="https://www.instagram.com/healthyliving.products?igsh=NGl6a3oxZXhrcmxr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="https://www.facebook.com/share/1CKjLukjVr/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
              </div>
            </div>

            <div>
              <div className="mb-8">
                <h4 className="text-xs font-bold uppercase mb-3">LOCATION</h4>
                <p className="text-gray-400">#2 Allen Avenue Near Tonyin Roundabout, Ikeja, Lagos - Nigeria</p>
              </div>
              <div className="mb-8">
                <h4 className="text-xs font-bold uppercase mb-3">PHONE</h4>
                <p className="text-gray-400">+234 815 435 8746</p>
                <p className="text-gray-400">+234 913 789 7299</p>
              </div>
              <div>
                <h4 className="text-xs font-bold uppercase mb-3">EMAIL</h4>
                <p className="text-gray-400">healthyliving.hello@gmail.com</p>
              </div>
            </div>

            <div>
              <div className="rounded-2xl overflow-hidden h-80">
                <img 
                  src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/6686b80771a03e2f4f8c9b19d31144a1.jpeg" 
                  alt="Organic Natural Solution" 
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8">
            <p className="text-sm text-gray-400 text-center">© 2025 Organic Natural Solution. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <button
        onClick={() => window.open('https://wa.me/2348154358746', '_blank')}
        className="fixed bottom-6 right-6 w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center z-50 transition-all hover:scale-110 cursor-pointer"
        aria-label="Contact us on WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </button>

      {/* Quick View Popup */}
      {selectedProduct && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setSelectedProduct(null)}>
          <div className="bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
              <h2 className="text-2xl font-bold text-gray-900">Product Details</h2>
              <button onClick={() => setSelectedProduct(null)} className="w-10 h-10 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors cursor-pointer">
                <i className="ri-close-line text-2xl text-gray-900"></i>
              </button>
            </div>

            <div className="p-6 md:p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className={`${selectedProduct.bg} rounded-3xl p-8 flex items-center justify-center`}>
                  <img src={selectedProduct.image} alt={selectedProduct.name} className="w-full h-auto object-contain" />
                </div>

                <div>
                  <p className="text-sm text-gray-500 mb-2">{selectedProduct.subtitle}</p>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">{selectedProduct.name}</h3>
                  
                  <div className="flex items-center gap-3 mb-6">
                    <div className="flex gap-1">
                      {[...Array(selectedProduct.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-500 text-lg"></i>
                      ))}
                    </div>
                    <span className="text-gray-600">({selectedProduct.reviews} reviews)</span>
                  </div>

                  <div className="mb-6">
                    <span className="text-xl text-gray-400 line-through mr-3">
                      ₦{Math.round(parseFloat(selectedProduct.price.replace(/[^0-9.]/g, '')) * 1.15).toLocaleString()}
                    </span>
                    <span className="text-4xl font-bold text-gray-900">{selectedProduct.price}</span>
                  </div>

                  <p className="text-gray-600 leading-relaxed mb-6">{selectedProduct.description}</p>

                  <button 
                    className={`w-full px-8 py-4 rounded-full font-medium transition-all duration-300 ${
                      addedToCart === selectedProduct.id
                        ? 'bg-teal-600 text-white'
                        : 'bg-gray-900 text-white hover:bg-teal-600'
                    } cursor-pointer`}
                    onClick={() => {
                      handleAddToCart(selectedProduct);
                      setTimeout(() => setSelectedProduct(null), 1500);
                    }}
                  >
                    {addedToCart === selectedProduct.id ? (
                      <span className="flex items-center justify-center gap-2">
                        <i className="ri-check-line"></i>
                        Added to Cart
                      </span>
                    ) : (
                      'Add to Cart'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
